import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/shared/shared.module";
import { IonicModule } from "@ionic/angular";
import { ResultTotalPage } from "./results-total/result-total";
import { ResultTeamsPage } from "./result-teams/result-teams";
import { ResultSearchPage } from "./result-search/result-search";
import { ResultRanglistPage } from "./result-ranglist/result-ranglist";
import { ResultProfilePage } from "./result-profile/result-profile";
import { ResultEventDetailsPage } from "./result-event-details/result-event-details";
import { ResultEditTrophyPage } from "./result-edit-trophy/result-edit-trophy";
import { ResultDescriptionPage } from "./result-description/result-description";
import { ResultCreatePagerPage } from "./result-create-pager/result-create-pager";
import { ResultCategoryPage } from "./result-category/result-category";
import { ResultAddPage } from "./result-add/result-add";
import { FormsModule } from "@angular/forms";
const routes: Routes = [
    { path: 'add', loadComponent: () =>
      import('./result-add/result-add').then(m => m.ResultAddPage)
    },
    { path: 'category', loadComponent: () =>
      import('./result-category/result-category').then(m =>m.ResultCategoryPage)
    },
    { path: 'create-pager', loadComponent: () =>
      import('./result-create-pager/result-create-pager').then(m =>m.ResultCreatePagerPage)
    },
    { path: 'description', loadComponent: () =>
      import('./result-description/result-description').then(m =>m.ResultDescriptionPage)
    },
    { path: 'details', loadChildren: () =>
      import('./result-details/result-details.module').then(m =>m.ResultDetailsModule)
    },
    { path: 'edit-trophy', loadComponent: () =>
      import('./result-edit-trophy/result-edit-trophy').then(m =>m.ResultEditTrophyPage)
    },
    { path: 'event-details', loadComponent: () =>
      import('./result-event-details/result-event-details').then(m =>m.ResultEventDetailsPage)
    },
    { path: 'profile', loadChildren: () =>
      import('./result-profile/result-profile').then(m =>m.ResultProfilePage)
    },
    { path: 'ranglist', loadComponent: () =>
      import('./result-ranglist/result-ranglist').then(m =>m.ResultRanglistPage)
    },
    { path: 'search', loadChildren: () =>
      import('./result-search/result-search').then(m =>m.ResultSearchPage)
    },
    { path: 'teams', loadChildren: () =>
      import('./result-teams/result-teams').then(m =>m.ResultTeamsPage)
    },
    { path: 'total', loadChildren: () =>
      import('./results-total/result-total').then(m =>m.ResultTotalPage)
    }
  ];
@NgModule({
    declarations: [
      ResultTotalPage,
      ResultTeamsPage,
      ResultSearchPage,
      ResultRanglistPage,
      ResultProfilePage,
      ResultEventDetailsPage,
      ResultEditTrophyPage,
      ResultDescriptionPage,
      ResultCreatePagerPage,
      ResultCategoryPage,
      ResultAddPage
    ],
    imports: [
        HttpClientModule,
        SharedModule,
        CommonModule,
        RouterModule,
        FormsModule,
        SharedModule,
        IonicModule,
        TranslateModule,
        RouterModule.forChild(routes)

    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
    ]
  })
  export class ResultsModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }